// VEPC Gestao - Central Administrativa: Tela de Planos, Modulos e Regras Beta
import { api } from '../api.js';

export async function renderPlanos() {
  const container = document.createElement('div');
  container.className = 'view-content';

  container.innerHTML = `
    <div class="view-header">
      <div class="view-title-group">
        <h2>Planos Comerciais & Módulos</h2>
        <p>Configuração dos planos oficiais do aplicativo Beta e propostas futuras de expansão.</p>
      </div>
    </div>

    <!-- Regras Oficiais Beta -->
    <div style="background: linear-gradient(135deg, #0F2B48 0%, #1A3E63 100%); color: white; border-radius: var(--radius-lg); padding: 24px; margin-bottom: 24px; box-shadow: var(--shadow-md);">
      <div style="display: flex; justify-content: space-between; align-items: flex-start; flex-wrap: gap: 16px;">
        <div>
          <div style="display: inline-flex; align-items: center; gap: 6px; background: rgba(194, 144, 35, 0.25); border: 1px solid var(--vepc-dourado); color: #F8D377; padding: 4px 10px; border-radius: var(--radius-sm); font-size: 11px; font-weight: 800; text-transform: uppercase;">
            ⭐ Regra Oficial de Preços — Aplicativo Beta
          </div>
          <h3 style="font-size: 20px; font-weight: 800; margin: 10px 0 6px; color: white;">
            Valor Básico: R$ 19,90/mês &bull; Módulo Adicional: +R$ 10,00/mês cada
          </h3>
          <p style="font-size: 13.5px; color: #CBD5E1; max-width: 800px; line-height: 1.5;">
            Os clientes podem optar pelo plano Básico (R$ 19,90), adicionar apenas 1 módulo (R$ 29,90) ou assinar o pacote Completo (R$ 39,90). Todos os módulos são controlados individualmente pela central.
          </p>
        </div>
        <div style="background: rgba(255, 255, 255, 0.1); border: 1px solid rgba(255, 255, 255, 0.2); border-radius: var(--radius-md); padding: 14px 18px; text-align: right;">
          <span style="font-size: 11px; font-weight: 700; text-transform: uppercase; color: #F8D377;">Garantia Vitalícia Beta</span>
          <div style="font-size: 13px; font-weight: 700; margin-top: 2px;">Preço & Recursos Protegidos</div>
          <div style="font-size: 11.5px; color: #CBD5E1; margin-top: 2px;">Imunes a aumentos pós-lançamento</div>
        </div>
      </div>
    </div>

    <!-- Seção 1: Planos do Aplicativo Beta -->
    <div style="margin-bottom: 32px;">
      <div style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 16px;">
        <h3 style="font-size: 17px; font-weight: 800; color: var(--vepc-azul-institucional); display: flex; align-items: center; gap: 8px;">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>
          Planos Oficiais do Aplicativo Beta (Vigentes)
        </h3>
        <span class="badge badge-sucesso" style="font-weight: 700;">Disponíveis para Contratação</span>
      </div>

      <div class="metrics-grid" id="grid-planos-beta" style="grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));">
        <div style="padding: 30px; text-align: center; color: var(--vepc-text-muted);">Carregando planos beta...</div>
      </div>
    </div>

    <!-- Seção 2: Planos Futuros de Expansão (Propostas) -->
    <div>
      <div style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 16px;">
        <div>
          <h3 style="font-size: 17px; font-weight: 800; color: var(--vepc-azul-institucional); display: flex; align-items: center; gap: 8px;">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polygon points="12 2 2 7 12 12 22 7 12 2"/><polyline points="2 17 12 22 22 17"/><polyline points="2 12 12 17 22 12"/></svg>
            Planos Futuros de Expansão (Propostas Comerciais)
          </h3>
          <p style="font-size: 12.5px; color: var(--vepc-text-muted);">
            Propostas de expansão cadastradas para planejamento. <u>Não disponibilizados comercialmente nesta fase</u>.
          </p>
        </div>
        <span class="badge badge-pendente" style="font-weight: 700;">Proposta Futura &bull; Não Ativo</span>
      </div>

      <div class="metrics-grid" id="grid-planos-futuros" style="grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));">
        <div style="padding: 30px; text-align: center; color: var(--vepc-text-muted);">Carregando propostas futuras...</div>
      </div>
    </div>

    <div id="modal-container-planos"></div>
  `;

  const gridBeta = container.querySelector('#grid-planos-beta');
  const gridFuturos = container.querySelector('#grid-planos-futuros');
  const modalContainer = container.querySelector('#modal-container-planos');

  async function carregarPlanos() {
    try {
      const data = await api.getPlanos();
      const planosBeta = data.planos_beta || [];
      const planosFuturos = data.planos_futuros_expansao || [];

      // Renderiza Planos Beta
      gridBeta.innerHTML = planosBeta.map(p => {
        let recursos = [];
        try { recursos = JSON.parse(p.recursos_json); } catch (e) { recursos = []; }

        return `
          <div class="card-panel" style="margin-bottom: 0; display: flex; flex-direction: column; border-top: 4px solid var(--vepc-primario);">
            <div class="panel-header" style="background: white; flex-direction: column; align-items: flex-start; gap: 4px;">
              <div style="display: flex; justify-content: space-between; width: 100%; align-items: center;">
                <span class="badge badge-beta" style="font-size: 10.5px;">BETA VIGENTE</span>
                <span style="font-size: 12px; color: var(--vepc-text-muted); font-weight: 600;">${p.total_empresas_vinculadas || 0} cliente(s)</span>
              </div>
              <h4 style="font-size: 17px; font-weight: 800; color: var(--vepc-azul-institucional); margin-top: 4px;">${p.nome}</h4>
            </div>

            <div class="panel-body" style="flex-grow: 1; display: flex; flex-direction: column; justify-content: space-between;">
              <div>
                <div style="margin-bottom: 14px;">
                  <span class="price-pill" style="font-size: 26px; color: var(--vepc-azul-institucional);">
                    R$ ${(p.preco_centavos / 100).toFixed(2).replace('.', ',')}
                  </span>
                  <span style="font-size: 13px; color: var(--vepc-text-muted);">/ mês</span>
                </div>

                <p style="font-size: 12.5px; color: var(--vepc-text-muted); margin-bottom: 14px; min-height: 48px;">
                  ${p.descricao}
                </p>

                <div style="border-top: 1px solid var(--vepc-border); padding-top: 12px; margin-bottom: 16px;">
                  <span style="font-size: 11px; font-weight: 700; text-transform: uppercase; color: var(--vepc-text-muted);">Recursos Inclusos:</span>
                  <ul style="list-style: none; padding-left: 0; margin-top: 8px; font-size: 12.5px; display: flex; flex-direction: column; gap: 6px;">
                    ${recursos.map(r => `
                      <li style="display: flex; align-items: flex-start; gap: 6px;">
                        <span style="color: var(--vepc-success); font-weight: bold;">✔</span>
                        <span>${r}</span>
                      </li>
                    `).join('')}
                  </ul>
                </div>
              </div>

              <div style="border-top: 1px solid var(--vepc-border); padding-top: 14px; display: flex; justify-content: space-between; align-items: center;">
                <div style="font-size: 11px; color: var(--vepc-text-muted);">
                  Código: <code style="font-family: var(--font-mono);">${p.codigo}</code>
                </div>
                <button class="btn btn-secondary btn-sm btn-editar-plano" data-id="${p.id}">
                  Editar Valores
                </button>
              </div>
            </div>
          </div>
        `;
      }).join('');

      // Renderiza Planos Futuros
      gridFuturos.innerHTML = planosFuturos.map(p => {
        let recursos = [];
        try { recursos = JSON.parse(p.recursos_json); } catch (e) { recursos = []; }

        return `
          <div class="card-panel" style="margin-bottom: 0; display: flex; flex-direction: column; border-top: 4px solid #CBD5E1; opacity: 0.9;">
            <div class="panel-header" style="background: white; flex-direction: column; align-items: flex-start; gap: 4px;">
              <div style="display: flex; justify-content: space-between; width: 100%; align-items: center;">
                <span class="badge" style="background: #F1F5F9; color: #475569; font-size: 10.5px;">PROPOSTA FUTURA</span>
                <span class="badge badge-limitada" style="font-size: 10px;">Não Ativo</span>
              </div>
              <h4 style="font-size: 16px; font-weight: 800; color: var(--vepc-azul-institucional); margin-top: 4px;">${p.nome}</h4>
            </div>

            <div class="panel-body" style="flex-grow: 1; display: flex; flex-direction: column; justify-content: space-between;">
              <div>
                <div style="margin-bottom: 14px;">
                  <span class="price-pill" style="font-size: 24px; color: #64748B;">
                    R$ ${(p.preco_centavos / 100).toFixed(2).replace('.', ',')}
                  </span>
                  <span style="font-size: 13px; color: var(--vepc-text-muted);">/ mês (previsto)</span>
                </div>

                <p style="font-size: 12px; color: var(--vepc-text-muted); margin-bottom: 14px; min-height: 48px;">
                  ${p.descricao}
                </p>

                <div style="border-top: 1px solid var(--vepc-border); padding-top: 12px; margin-bottom: 16px;">
                  <span style="font-size: 11px; font-weight: 700; text-transform: uppercase; color: var(--vepc-text-muted);">Recursos Planejados:</span>
                  <ul style="list-style: none; padding-left: 0; margin-top: 8px; font-size: 12px; display: flex; flex-direction: column; gap: 5px;">
                    ${recursos.map(r => `
                      <li style="display: flex; align-items: flex-start; gap: 6px;">
                        <span style="color: var(--vepc-text-subtle);">○</span>
                        <span>${r}</span>
                      </li>
                    `).join('')}
                  </ul>
                </div>
              </div>

              <div style="border-top: 1px solid var(--vepc-border); padding-top: 14px; display: flex; justify-content: space-between; align-items: center;">
                <div style="font-size: 11px; color: var(--vepc-text-muted);">
                  Código: <code style="font-family: var(--font-mono);">${p.codigo}</code>
                </div>
                <button class="btn btn-secondary btn-sm btn-editar-plano" data-id="${p.id}">
                  Ajustar Proposta
                </button>
              </div>
            </div>
          </div>
        `;
      }).join('');

      // Eventos de clique para editar valores do plano
      container.querySelectorAll('.btn-editar-plano').forEach(btn => {
        btn.onclick = () => abrirModalEditarPlano(btn.dataset.id, [...planosBeta, ...planosFuturos]);
      });

    } catch (err) {
      gridBeta.innerHTML = `<div style="padding: 20px; color: var(--vepc-danger);">Falha ao carregar planos: ${err.message}</div>`;
    }
  }

  // Modal para editar plano sem alterar código-fonte
  function abrirModalEditarPlano(planoId, listaPlanos) {
    const plano = listaPlanos.find(p => p.id === planoId);
    if (!plano) return;

    modalContainer.innerHTML = `
      <div class="modal-backdrop">
        <div class="modal-card">
          <div class="modal-header">
            <h3 style="font-size: 16px; font-weight: 800; color: var(--vepc-azul-institucional);">Configurar Plano Comercial</h3>
            <button class="btn btn-secondary btn-sm btn-fechar-modal">&times;</button>
          </div>
          <form id="form-editar-plano">
            <div class="modal-body">
              <div class="form-group">
                <label class="form-label">Nome do Plano</label>
                <input type="text" id="plano-nome" class="form-control" value="${plano.nome}" required />
              </div>

              <div class="form-row">
                <div class="form-group">
                  <label class="form-label">Preço Mensal (em Reais R$)</label>
                  <input type="number" step="0.01" id="plano-preco" class="form-control" value="${(plano.preco_centavos / 100).toFixed(2)}" required />
                </div>
                <div class="form-group">
                  <label class="form-label">Status do Plano</label>
                  <select id="plano-status" class="form-control">
                    <option value="vigente" ${plano.status === 'vigente' ? 'selected' : ''}>Vigente (Ativo para Contratação)</option>
                    <option value="proposta_futura" ${plano.status === 'proposta_futura' ? 'selected' : ''}>Proposta Futura (Não Disponível)</option>
                    <option value="arquivado" ${plano.status === 'arquivado' ? 'selected' : ''}>Arquivado</option>
                  </select>
                </div>
              </div>

              <div class="form-group">
                <label class="form-label">Descrição Comercial</label>
                <textarea id="plano-descricao" class="form-control" rows="3">${plano.descricao}</textarea>
              </div>

              <div class="alert-box alert-info" style="margin-bottom: 0;">
                <svg class="alert-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><path d="M12 16v-4m0-4h.01"/></svg>
                <div style="font-size: 12px;">
                  <strong>Separação Estrita de Código e Configuração:</strong>
                  A alteração deste valor atualiza apenas a tabela administrativa de planos no banco de dados. Os contratos antigos de clientes Beta com valor protegido permanecem inalterados.
                </div>
              </div>
            </div>

            <div class="modal-footer">
              <button type="button" class="btn btn-secondary btn-sm btn-fechar-modal">Cancelar</button>
              <button type="submit" class="btn btn-primary btn-sm">Salvar Configuração</button>
            </div>
          </form>
        </div>
      </div>
    `;

    modalContainer.querySelectorAll('.btn-fechar-modal').forEach(b => {
      b.onclick = () => { modalContainer.innerHTML = ''; };
    });

    const form = modalContainer.querySelector('#form-editar-plano');
    form.onsubmit = async (e) => {
      e.preventDefault();
      const novoPrecoReais = parseFloat(modalContainer.querySelector('#plano-preco').value);
      const centavos = Math.round(novoPrecoReais * 100);

      try {
        await api.atualizarPlano(planoId, {
          nome: modalContainer.querySelector('#plano-nome').value,
          preco_centavos: centavos,
          status: modalContainer.querySelector('#plano-status').value,
          descricao: modalContainer.querySelector('#plano-descricao').value
        });
        alert('Plano atualizado com sucesso no banco de dados!');
        modalContainer.innerHTML = '';
        carregarPlanos();
      } catch (err) {
        alert('Erro ao atualizar plano: ' + err.message);
      }
    };
  }

  carregarPlanos();
  return container;
}
